import { z } from "zod";
import { iconSchema } from "../zod/iconSchema.js";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const benefitsBlockSchema = z.object({
	benefits: z.array(
		z.object({
			icon: iconSchema,
			heading: nonEmptyString,
			description: nonEmptyString,
		}),
	),
});
